import { gql, type TypedDocumentNode } from "@apollo/client";
import type { CommissionAllocationAgreementNode, CommissionAllocationAgreementStatus } from "./types";

export interface CommissionAllocationAgreementLiveQueryResponse {
  commissionAllocationAgreementLive: CommissionAllocationAgreementNode | null;
}

export interface CommissionAllocationAgreementLiveQueryVariables {
  campaignId: string;
  receiverCrmPersonId: string;
  asOf?: string;
}

export const COMMISSION_ALLOCATION_AGREEMENT_LIVE_QUERY: TypedDocumentNode<
  CommissionAllocationAgreementLiveQueryResponse,
  CommissionAllocationAgreementLiveQueryVariables
> = gql`
  query CommissionAllocationAgreementLive($campaignId: ID!, $receiverCrmPersonId: ID!, $asOf: ISO8601DateTime) {
    commissionAllocationAgreementLive(campaignId: $campaignId, receiverCrmPersonId: $receiverCrmPersonId, asOf: $asOf) {
      id
      commissionCampaignId
      receiverCrmPersonId
      crmFacilityId
      facilityName
      status
      effectiveStart
      effectiveEnd
      splits {
        id
        crmPersonId
        pgaId
        displayName
        splitPercent
        hasActiveFaa
      }
    }
  }
`;

export interface CommissionAllocationAgreementsQueryResponse {
  commissionAllocationAgreements: {
    nodes: CommissionAllocationAgreementNode[];
    totalCount: number;
  };
}

export interface CommissionAllocationAgreementsQueryVariables {
  receiverCrmPersonId: string;
  campaignId?: string;
  status?: CommissionAllocationAgreementStatus;
}

export const COMMISSION_ALLOCATION_AGREEMENTS_QUERY: TypedDocumentNode<
  CommissionAllocationAgreementsQueryResponse,
  CommissionAllocationAgreementsQueryVariables
> = gql`
  query CommissionAllocationAgreements(
    $receiverCrmPersonId: ID!
    $campaignId: ID
    $status: BackofficeCommissionAllocationAgreementStatus
  ) {
    commissionAllocationAgreements(
      receiverCrmPersonId: $receiverCrmPersonId
      campaignId: $campaignId
      status: $status
    ) {
      nodes {
        id
        commissionCampaignId
        receiverCrmPersonId
        crmFacilityId
        facilityName
        status
        effectiveStart
        effectiveEnd
        splits {
          id
          crmPersonId
          pgaId
          displayName
          splitPercent
          hasActiveFaa
        }
      }
      totalCount
    }
  }
`;
